import { makeStyles } from '../../../styles';
export default makeStyles((theme) => ({
    root: {
        width: 200,
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
        background: theme.colors.primary.contrastWhite,
        border: `1px solid ${theme.colors.gray[200]}`,
        boxShadow: '0px 10px 15px rgba(31, 41, 55, 0.1), 0px 4px 6px rgba(31, 41, 55, 0.05)',
        marginTop: 4,
    },
    hexFieldContainer: {
        marginTop: 8,
    },
    hexField: {
        marginTop: 4,
    },
}));
//# sourceMappingURL=ColorPicker.styles.js.map